import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-background" data-testid="auth-callback">
      <div className="overline animate-pulse">Signing you in</div>
    </div>
  );
}
